import { Auth } from 'aws-amplify'

// used by `Nav`
export async function signOut(): Promise<void> {
  if (window.Cypress) {
    // mocking the Hub sign-out event triggering a local storage clear for the integration test
    localStorage.clear()
    return
  }
  await Auth.signOut()
}
